import { Grid } from '@material-ui/core';
import styled from 'styled-components';

const footerHeight: string = '60px';

export const FooterLink = styled.a`
  cursor: pointer;
  color: white; 
  text-decoration: none;
  display: block;
  flex: 1;
  line-height: ${footerHeight};
  text-align: center;
  padding-left: 10px;
  padding-right: 10px;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow-x: hidden;
`;

export const FooterContainer = styled(Grid)`
  background-color: #33374C; 
  padding-left: 20px;
  padding-right: 20px;
`;

export const LinksContainer = styled(Grid)`
  && {
      max-width: 800px;
      margin-left: auto; 
      margin-right: auto;
  }
`;



// WEBPACK FOOTER //
// ./src/components/footer-links/styles.tsx